import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusPresentation() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/x4ZFy1Tvh8UQZ75dG1Cae7/BONO__1.png',
    title: 'El Guion Anti-Culpa',
    subtitle: '15 frases listas para límites sin drama',
    description: 'Frases listas para copiar, pegar y usar hoy mismo. Para cuando no sabes cómo decir "hoy no puedo" sin sentirte mala persona. Para cuando tu familia dice "avísame"… pero nunca aparece. Para cuando pones un límite y te contraatacan con culpa.',
    features: ['15 frases para 5 tipos de límites (tiempo, dinero, logística, emocional, urgencias)', 'Respuestas cortas a 6 contraataques típicos', 'Tarjetas imprimibles + versión móvil para copiar/pegar en WhatsApp', 'Checklist de antes/durante/después de una conversación difícil']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/bQu3ChodBKnNxjPkhArEPp/BONO__2.png',
    title: 'Plantilla "Reparto Sin Pleito"',
    subtitle: 'La lista de tareas que obliga a decidir',
    description: 'Deja de pedir "ayuda" en general. Empieza a pedir una tarea concreta, con fecha y responsable. Porque cuando la petición es vaga, la respuesta siempre es "sí claro… ya veo." Y tú terminas haciéndolo solo(a) otra vez.',
    features: ['Lista maestra de 40 tareas del cuidado (listas para delegar)', 'Plantilla editable "Quién Hace Qué" (con dueño + fecha + plan B)', 'Mensajes listos para pedir ayuda sin rogar', 'Mini-guía de seguimiento sin discutir']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/6hSimUXc3sr6DhScHJjwyK/BONO__3.png',
    title: 'Checklist "Semana de Aire"',
    subtitle: 'Recuperación mínima viable en 7 días',
    description: 'No es una rutina perfecta. Es el plan más corto y honesto para que esta semana termines con más aire que la anterior.',
    features: ['Plan de 7 días con acciones mínimas (versión normal + versión MINI para días imposibles)', 'Semáforo de energía para decidir sin agotarte más', 'Menú de 10 microdescansos de 5 minutos (usables en crisis)', 'Tracker diario simple para ver progreso real', 'Versión SOS para los días en ROJO']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/fQFG5BtV5HHrWJZ7iSBtSp/PORTADA_BONO__4.png',
    title: 'Mapa Express de Decisiones',
    subtitle: 'Claridad inmediata cuando todo parece urgente',
    description: 'Cuando la mente se nubla y sientes que todo es una emergencia, este mapa te guía paso a paso para decidir sin agotarte y sin entrar en pánico. Te devuelve control, calma y dirección en los momentos más tensos.',
    features: ['Protocolo de "Falsa Emergencia" para distinguir lo urgente de lo que puede esperar', 'Guía de Priorización Diaria para elegir solo lo esencial cuando no tienes energía', 'Checklist de Relevo Rápido para delegar en 5 minutos sin miedo a que algo se olvide']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/7fJFWFXTCmUbErHCPKACXu/PORTADA_BONO__5.png',
    title: 'El Kit de "Evidencia Invisible"',
    subtitle: 'Haz visible tu carga sin pelear ni justificarte',
    description: 'Muchos familiares minimizan tu esfuerzo porque todo "parece bajo control". Este kit te ayuda a mostrar la realidad de tu carga con datos claros, sin discusiones y sin sentirte culpable.',
    features: ['Log de Actividades Maestro para documentar tus horas reales de cuidado', 'Plantilla de Gastos Hormiga para registrar cada peso y evitar malentendidos', 'Semáforo de Desgaste para comunicar cuándo estás entrando en zona de riesgo']
  }];
  return <section className="py-10 px-4 bg-cream" data-id="element-72">
      <div className="max-w-6xl mx-auto space-y-10" data-id="element-73">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: index * 0.2
      }} className={`grid grid-cols-1 md:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`} data-id="element-74">
            {/* Image */}
            <div className={`relative ${index % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-75">
              <div className="absolute inset-0 bg-terracotta/10 transform rotate-3 rounded-2xl" data-id="element-76"></div>
              <img src={bonus.image} alt={`Portada ${bonus.title}`} className="relative rounded-2xl shadow-xl w-full max-w-sm mx-auto" data-id="element-77" />
            </div>

            {/* Content */}
            <div className={`space-y-4 ${index % 2 === 1 ? 'md:order-1' : ''}`} data-id="element-78">
              <div className="flex items-center gap-3" data-id="element-79">
                <Gift className="w-8 h-8 text-terracotta shrink-0" aria-hidden="true" data-id="element-80" />
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy" data-id="element-81">
                  BONO #{index + 1}
                </h3>
              </div>

              <div data-id="element-82">
                <h4 className="text-xl md:text-2xl font-serif font-bold text-navy mb-2" data-id="element-83">
                  {bonus.title}
                </h4>
                <p className="text-lg text-terracotta italic mb-4" data-id="element-84">
                  "{bonus.subtitle}"
                </p>
                <p className="text-base text-navy/80 leading-relaxed" data-id="element-85">
                  {bonus.description}
                </p>
              </div>

              <div data-id="element-86">
                <p className="text-sm font-semibold text-navy mb-3 uppercase tracking-wider" data-id="element-87">
                  Lo que incluye:
                </p>
                <ul className="space-y-3" data-id="element-88">
                  {bonus.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start gap-3" data-id="element-89">
                      <span className="w-1.5 h-1.5 bg-terracotta rounded-full mt-2 shrink-0" data-id="element-90"></span>
                      <span className="text-navy/80 leading-relaxed" data-id="element-91">
                        {feature}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}